import axios, { CancelTokenSource } from 'axios';
import { deleteWhenAuthorized, getWhenAuthorized, patchWhenAuthorized, postWhenAuthorized } from './api';

export interface IAttachmentsState {
    attachments: File[];
}

export const initialAttachmentsState: IAttachmentsState = {
    attachments: []
}

export const getGroupMeeting = async (groupId: string, meetingId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/meetings/${meetingId}`, cancelTokenSource);

export const removeMeetingDocument = async (groupId: string, meetingId: string, documentId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await deleteWhenAuthorized(() => `/api/group/${groupId}/meetings/${meetingId}/${encodeURI(documentId)}`, cancelTokenSource);

export const signupPerson = async (groupId: string, meetingId: string, personId: number, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await patchWhenAuthorized(() => `/api/group/${groupId}/meetings/${meetingId}/${personId}`, { status: 'ACCEPTED' }, cancelTokenSource);

export const cancelPerson = async (groupId: string, meetingId: string, personId: number, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await patchWhenAuthorized(() => `/api/group/${groupId}/meetings/${meetingId}/${personId}`, { status: 'DECLINED' }, cancelTokenSource);

export const resendInvitation = async (groupId: string, meetingId: string, personId: number, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await postWhenAuthorized(() => `/api/group/${groupId}/meetings/${meetingId}/${personId}`, null, cancelTokenSource);

export const sendReminder = async (groupId: string, meetingId: string, reminderDescription: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await postWhenAuthorized(() => `/api/group/${groupId}/meetings/${meetingId}/reminder`, { reminderDescription }, cancelTokenSource);

export const downloadParticipantStatuses = async (groupId: string, meetingId: string, status: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await getWhenAuthorized(() => `/api/group/${groupId}/meetings/${meetingId}/participants.csv?status=${status}`, cancelTokenSource, 'blob');

export const addAttachments = async (groupId: string, meetingId: string, attachmentsRequest: IAttachmentsState, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => {
    try {
        const formData = new FormData();

        for (const file of attachmentsRequest.attachments) {
            formData.append('attachments', file);
        }

        return await postWhenAuthorized(() => `/api/group/${groupId}/meetings/${meetingId}/attachments`, formData, cancelTokenSource);
    } catch (error) {
        if (!axios.isCancel(error)) {
            throw error;
        }
    }

    return undefined;
}

export const addFavoriteDocument = async (groupId: string, documentId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await postWhenAuthorized(() => `/api/group/${groupId}/meetings/addfavoritedocument`, { documentId }, cancelTokenSource);

export const removeFavoriteDocument = async (groupId: string, documentId: string, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await postWhenAuthorized(() => `/api/group/${groupId}/meetings/removefavoritedocument`, { documentId }, cancelTokenSource);